/** Canonical detection labels from hair analysis (see qwen_hair_analysis ALLOWED_LABELS). */

export const HAIR_ANALYSIS_CONDITION_OPTIONS = [
  'Dandruff',
  'Spot Baldness',
  'Scalp Rash',
  'Rough/Straw Hair',
  'Scalp Pimples',
  'Silver/White Hair',
  'Thinning Stage 1',
  'Thinning Stage 2',
  'Thinning Stage 3',
  'Thinning Stage 4',
  'Hair Bugs',
  'Greasy Hair',
  'Thick Scaling',
];

const CANONICAL = new Set(HAIR_ANALYSIS_CONDITION_OPTIONS);

const ALIASES = {
  dandruff: 'Dandruff',
  'spot baldness': 'Spot Baldness',
  'alopecia areata': 'Spot Baldness',
  'bald spot': 'Spot Baldness',
  baldness: 'Spot Baldness',
  'scalp rash': 'Scalp Rash',
  'scalp inflammation': 'Scalp Rash',
  'rough/straw hair': 'Rough/Straw Hair',
  'rough hair': 'Rough/Straw Hair',
  'straw hair': 'Rough/Straw Hair',
  'dry hair': 'Rough/Straw Hair',
  breakage: 'Rough/Straw Hair',
  'scalp pimples': 'Scalp Pimples',
  'silver/white hair': 'Silver/White Hair',
  'silver hair': 'Silver/White Hair',
  'white hair': 'Silver/White Hair',
  'grey hair': 'Silver/White Hair',
  'gray hair': 'Silver/White Hair',
  thinning: 'Thinning Stage 2',
  'thinning hair': 'Thinning Stage 2',
  'thinning stage 1': 'Thinning Stage 1',
  'thinning stage 2': 'Thinning Stage 2',
  'thinning stage 3': 'Thinning Stage 3',
  'thinning stage 4': 'Thinning Stage 4',
  'hair bugs': 'Hair Bugs',
  'hair bug': 'Hair Bugs',
  lice: 'Hair Bugs',
  'greasy hair': 'Greasy Hair',
  'greasy / oily hair': 'Greasy Hair',
  'oily hair': 'Greasy Hair',
  'oily scalp': 'Greasy Hair',
  'thick scaling': 'Thick Scaling',
  scaling: 'Thick Scaling',
  'product buildup': 'Thick Scaling',
  dryness: 'Rough/Straw Hair',
};

export function normalizeHairDetectionLabel(label) {
  const text = String(label || '').trim();
  if (!text) return null;
  if (CANONICAL.has(text)) return text;
  const lower = text.toLowerCase();
  if (lower === 'healthy scalp' || lower === 'normal scalp') return null;
  if (ALIASES[lower]) return ALIASES[lower];
  for (const [key, canonical] of Object.entries(ALIASES)) {
    if (lower.includes(key)) return canonical;
  }
  return CANONICAL.has(text) ? text : null;
}
